export const isAdmin = () => {
    // Отсутствие ролей означает разное: security выключена (тогда всё разрешено)
    // или сессия протухла (тогда наоборот, доступ надо прятать). Различаем через
    // отдельный флаг, который App.js пишет по ответу /config.
    const securityEnabled = localStorage.getItem("securityEnabled");
    if (securityEnabled !== null) {
        try {
            if (JSON.parse(securityEnabled) === false) {
                return true;
            }
        } catch (ex) {
            // упало — считаем как будто флага нет, проверим роли ниже
        }
    }

    const roles = localStorage.getItem("roles");
    if (!roles) {
        // Флаг ещё не пришёл (самая первая загрузка) или security включена,
        // а роли пропали (протухшая сессия) — в обоих случаях лучше скрыть
        // админские кнопки, чем на мгновение показать лишние.
        return false;
    }

    try {
        return JSON.parse(roles).includes("admin");
    } catch (ex) {
        return false;
    }
};

export const setRoles = (roles) => {
    if (roles) {
        localStorage.setItem("roles", JSON.stringify(roles));
    }
};

export const setSecurityEnabled = (isSecurityEnabled) => {
    localStorage.setItem("securityEnabled", JSON.stringify(isSecurityEnabled));
};

export const forgetSecurityEnabled = () => {
    localStorage.removeItem("securityEnabled");
};

export const setViewerRole = () => {
    localStorage.setItem("roles", JSON.stringify(['viewer']));
};
